<div class="st-topic-item-condensed-border-left"
     leftBorder
     [record]="data">
</div>
<ng-container *ngIf="data">

    <div class="st-topic-item-condensed-container"
         [class.st-topic-item-condensed-container__mouse-entered]="mouseEntered"
         (mouseenter)="onMouseEnter()"
         (mouseleave)="onMouseLeave()">
        <div *ngIf="extraOwnerCount > 0"
             class="st-topic-item-condensed-container-badge"
             [matBadge]="extraOwnerCount"
             matBadgeSize="small"
             matBadgePosition="below">
        </div>
        <avatar big
                #triggerOverlay="cdkOverlayOrigin"
                cdkOverlayOrigin
                (mouseenter)="showStaffTooltip(data?.storyOwner)"
                (mouseleave)="onStoryOwnerMouseOut($event)"
                [userId]="data?.storyOwner?.[0]">
        </avatar>
        <div class="st-topic-item-condensed-container-story">
            <div class="st-topic-item-condensed-container-story-header">
                <div class="st-topic-item-condensed-container-story-header--title">{{title}}</div>
                <div class="st-topic-item-condensed-container-story-header--borders">
                    <div class="st-topic-item-condensed-container-story-header--borders__item"
                         *ngFor="let item of data?.topicType"
                         topicCardTypeColor
                         [matTooltip]="item"
                         [itemType]="item"
                         [record]="data">
                    </div>
                </div>
            </div>
            <div class="st-topic-item-condensed-container-story--desc"
                 [class.st-topic-item-condensed-valid]="globalTablesService.FieldDefsDict[this.pstFieldNames.PSTTopicSummary]?.Required && !data?.summary">
                {{description}}
            </div>
        </div>
        <ng-template cdkConnectedOverlay
                     #storyOwnerEl
                     [cdkConnectedOverlayOrigin]="triggerOverlay"
                     [cdkConnectedOverlayOpen]="isListOpen"
                     (attach)="storyOwnerPanelAttached()">
            <staff-id-list-tooltip [users]="tooltipUsers">
            </staff-id-list-tooltip>
        </ng-template>
        <ng-template ngFor
                     let-item
                     [ngForOf]="viewStateCustomCondensedItems">
            <div *ngIf="shouldShowCustomFields"
                 [matTooltip]="getItemString(item)"
                 class="st-topic-item-condensed-container-custom-fields">
                {{ getItemString(item) }}
            </div>
        </ng-template>

        <div class="st-topic-item-condensed-container-desk">
            <span> {{topicGroupsItem}}</span>
        </div>

        <div class="st-topic-item-condensed-container-status">
            <span>{{status}}</span>
        </div>

        <div class="st-topic-item-condensed-container-assignments"
             #triggerAssignmentOverlay="cdkOverlayOrigin"
             cdkOverlayOrigin
             (mouseleave)="onMouseOutAssignments($event)"
             (mouseenter)="isAssignmentsPanelOpen = true">
            <icon *ngIf="data?.children[0]"
                  hasBorder
                  [type]="data?.children[0]?.coverageType"
                  (click)="onAssignmentOpen.emit(data?.children[0])"
                  [record]="data?.children[0]"></icon>
            <icon *ngIf="data?.children[1]"
                  hasBorder
                  [type]="data?.children[1]?.coverageType"
                  (click)="onAssignmentOpen.emit(data?.children[1])"
                  [record]="data?.children[1]"></icon>
            <icon *ngIf="data?.children[2]"
                  hasBorder
                  [type]="data?.children[2]?.coverageType"
                  (click)="onAssignmentOpen.emit(data?.children[2])"
                  [record]="data?.children[2]"></icon>
            <button mat-icon-button
                    class="st-topic-item-condensed-container-assigns__assignments-extraCount"
                    *ngIf="shouldShowExtraAssignments; else noExtraAssignments">
                +{{extraAssignmentsCount}}
            </button>
            <ng-template #noExtraAssignments>
                <icon *ngIf="data?.children[3]"
                      hasBorder
                      [type]="data?.children[3]?.coverageType"
                      (click)="onAssignmentOpen.emit(data?.children[3])"
                      [record]="data?.children[3]"></icon>
            </ng-template>
        </div>
        <button mat-button
                click-stop-propagation
                [disabled]="isReadOnly"
                (click)="updateTopic(!data.pstApproved, pstFieldNames.PSTApproved)"
                *ngIf="globalTablesService.FieldDefsDict[pstFieldNames?.PSTApproved]?.TopicProp"
                [matTooltip]="globalTablesService.FieldDefsDict[pstFieldNames.PSTApproved]?.DefaultCaption"
                class="st-topic-item-condensed-container-approve"
                [class.st-topic-item-condensed-container-approve--active]="data?.pstApproved">
            <mat-icon fontSet="material-symbols-outlined">done</mat-icon>
        </button>
        <div *ngIf="!isPublication">
            <button mat-icon-button
                    click-stop-propagation
                    #trigger="cdkOverlayOrigin"
                    cdkOverlayOrigin
                    (click)="isPanelOpen = true"
                    class="st-topic-item-condensed-container__more">
                <mat-icon>more_horiz</mat-icon>
            </button>

            <ng-template *ngIf="!isPublication"
                         #externalActions>
                <ng-template #externalActionsEl
                             cdkConnectedOverlay
                             [cdkConnectedOverlayOrigin]="trigger"
                             [cdkConnectedOverlayOpen]="isPanelOpen"
                             (overlayOutsideClick)="isPanelOpen = false">
                    <external-actions-overlay [data]="data"
                                              [editable]="topicEditable"
                                              [isPanelOpen]="isPanelOpen"
                                              [onObjectOpen]="onTopicOpen"
                                              (onActionClick)="isPanelOpen = false">
                    </external-actions-overlay>
                </ng-template>
            </ng-template>
        </div>

        <button mat-icon-button
                *ngIf="isPublication"
                [disabled]="isReadOnly"
                class="st-topic-item-condensed-container__delete"
                (click)="deletePublication($event)">
            <mat-icon>delete_outline</mat-icon>
        </button>

        <ng-template #assignmentsOverlay>
            <ng-template #assignmentsOverlayEl
                         cdkConnectedOverlay
                         [cdkConnectedOverlayOrigin]="triggerAssignmentOverlay"
                         [cdkConnectedOverlayOpen]="isAssignmentsPanelOpen"
                         (attach)="assignmentsPanelAttached()">
                <assignments-overlay [data]="data"
                                     [editable]="topicEditable"
                                     [isPanelOpen]="isAssignmentsPanelOpen"
                                     [onObjectOpen]="onAssignmentOpen">
                </assignments-overlay>
            </ng-template>
        </ng-template>
    </div>

</ng-container>
